import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "react-lottie-player";

// Fondo animado
import fuegoamarillo from "./assets/lottie/fuegoamarillo.json";

export default function PendingPage() {
  const navigate = useNavigate();

  function CardTranslucido() {
    const [progress, setProgress] = useState(0);
    const [complete, setComplete] = useState(false);

    useEffect(() => {
      let current = 0;
      const interval = setInterval(() => {
        current += 3;
        if (current >= 100) {
          current = 100;
          setComplete(true);
          clearInterval(interval);
        }
        setProgress(current);
      }, 55);

      return () => clearInterval(interval);
    }, []);

    return (
      <div
        style={{
          width: "90%",
          maxWidth: "clamp(280px, 50vw, 360px)",
          borderRadius: "clamp(14px, 2.5vw, 22px)",
          backgroundColor: "rgba(41,40,40,0.50)",
          backdropFilter: "blur(6px)",
          padding: "clamp(16px, 3vw, 26px)",
          boxShadow: "0 0 18px rgba(0,0,0,0.45)",
          pointerEvents: "auto",
          textAlign: "center",
        }}
      >
        {/* Logo circular */}
        <div
          style={{
            width: "clamp(85px, 20vw, 120px)",
            height: "clamp(85px, 20vw, 120px)",
            margin: "0 auto",
            borderRadius: "50%",
            backgroundColor: "#ff9500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 0 15px rgba(0,0,0,0.3)",
          }}
        >
          <div
            style={{
              width: "clamp(74px, 18vw, 108px)",
              height: "clamp(74px, 18vw, 108px)",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#444",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={"images/dragonfondo.png"}
              alt="logo"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "dragonfondo.png";
              }}
            />
          </div>
        </div>

        {/* Mientras carga */}
        {!complete && (
          <>
            <div
              style={{
                width: "100%",
                height: "clamp(8px, 1.8vw, 12px)",
                backgroundColor: "#ccc",
                borderRadius: "clamp(4px, 1vw, 8px)",
                marginTop: "clamp(14px, 2.5vw, 20px)",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${progress}%`,
                  height: "100%",
                  background: "linear-gradient(90deg, #ffb347, #ff9500)",
                  transition: "width 0.15s ease",
                }}
              />
            </div>

            <p
              style={{
                marginTop: "clamp(6px, 1.2vw, 10px)",
                color: "#eee",
                fontWeight: "bold",
                fontSize: "clamp(11.5px, 2.4vw, 15px)",
              }}
            >
              Verificando pago... {progress}%
            </p>

            <p
              style={{
                marginTop: "clamp(6px, 1.5vw, 12px)",
                color: "#ddd",
                opacity: 0.85,
                fontSize: "clamp(10px, 2.4vw, 14px)",
              }}
            >
              Mercado Pago está procesando tu transacción.  
              No cierres esta ventana.
            </p>
          </>
        )}

        {/* Cuando llegue a 100% */}
        {complete && (
          <div
            style={{
              marginTop: "clamp(16px, 3vw, 24px)",
              color: "white",
            }}
          >
            <h3
              style={{
                margin: 0,
                fontSize: "clamp(13px, 3vw, 18px)",
                fontWeight: "bold",
              }}
            >
              Aún estamos verificando tu pago
            </h3>

            <p
              style={{
                marginTop: "clamp(8px, 1.8vw, 13px)",
                opacity: 0.9,
                fontSize: "clamp(10.5px, 2.7vw, 14px)",
              }}
            >
              Este proceso puede tardar unos segundos según tu método
              de pago.
            </p>

            <button
              style={{
                marginTop: "clamp(14px, 2.7vw, 22px)",
                width: "100%",
                backgroundColor: "#ff9500",
                padding: "clamp(9px, 2.4vw, 13px)",
                fontSize: "clamp(13px, 2.8vw, 17px)",
                borderRadius: "clamp(8px, 1.8vw, 14px)",
                border: "none",
                color: "white",
                fontWeight: "bold",
                cursor: "pointer",
                boxShadow: "0 0 10px rgba(0,0,0,0.3)",
              }}
              onClick={() => navigate("/checkout")}
            >
              Volver al pago
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {/* Fondo negro */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "black",
          zIndex: 0,
        }}
      />

      {/* Animación Lottie */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
          pointerEvents: "none",
        }}
      >
        <Lottie
          animationData={fuegoamarillo}
          play
          loop
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* Botón regresar */}
      <button
        onClick={() => navigate("/")}
        style={{
          position: "fixed",
          top: "clamp(10px, 2vw, 22px)",
          left: "clamp(10px, 2vw, 22px)",
          zIndex: 3,
          background: "rgba(0,0,0,0.45)",
          color: "white",
          padding: "clamp(5px, 1.5vw, 10px) clamp(8px, 2.5vw, 14px)",
          borderRadius: "clamp(6px, 1.2vw, 10px)",
          border: "1px solid rgba(255,255,255,0.25)",
          cursor: "pointer",
          fontSize: "clamp(11px, 2.7vw, 15px)",
          backdropFilter: "blur(4px)",
        }}
      >
        ← Regresar
      </button>

      {/* Card principal */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
          pointerEvents: "none",
        }}
      >
        <CardTranslucido />
      </div>
    </>
  );
}
